// Окно «Подтвердите простой» и утренний обзвон — чистые функции (решение Анны 03.11.2026).

export const STAGE_TEXT = {
  0: '',
  1: 'Позвоните водителю',
  2: 'Логист не ответил — подключён руководитель',
  3: 'Запас до срока — ответьте сейчас',
  4: 'Срок прошёл',
}

export function leftText(minutes) {
  if (minutes == null || Number.isNaN(minutes)) return ''
  if (minutes <= 0) return 'срок прошёл'
  if (minutes < 60) return 'осталось ' + minutes + ' мин'
  const h = Math.floor(minutes / 60)
  const m = minutes % 60
  return 'осталось ' + h + ' ч' + (m ? ' ' + m + ' мин' : '')
}

// «14:30», «9:05» → «14:30» / «09:05»; иначе null.
export function normalizeTime(value) {
  const match = String(value || '').trim().match(/^(\d{1,2})[:.](\d{2})$/)
  if (!match) return null
  const h = Number(match[1])
  const m = Number(match[2])
  if (h > 23 || m > 59) return null
  return String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0')
}

// Утренний обзвон — отдельным списком сверху, остальные — по сроку.
export const CALL_KINDS = ['morning', 'evening']
export const isCall = (item) => CALL_KINDS.includes(item?.kind)

export function groupChecks(items) {
  const list = Array.isArray(items) ? items : []
  const morning = list.filter(isCall)
  const downtime = list.filter((i) => !isCall(i)).sort((a, b) => (a.minutes_left ?? 0) - (b.minutes_left ?? 0))
  return { morning, downtime }
}

export function headline(data) {
  const items = data?.items || []
  if (!items.length) return ''
  const { morning, downtime } = groupChecks(items)
  if (data.blocking) return 'ПОДТВЕРДИТЕ — РАБОТА В ERP ОСТАНОВЛЕНА ДО ОТВЕТА'
  if (morning.length && !downtime.length) {
    const evening = morning.every((i) => i.kind === 'evening')
    return (evening ? 'ВЕЧЕРНИЙ ОБЗВОН ВОДИТЕЛЕЙ: ' : 'УТРЕННИЙ ОБЗВОН ВОДИТЕЛЕЙ: ') + morning.length
  }
  return 'ПОДТВЕРДИТЕ ПРОСТОЙ: ' + items.length
}

export const OUTBOX_STATUS = {
  draft: 'Ждёт подтверждения',
  sent: 'Отправлено',
  failed: 'Не ушло — повторите',
  rejected: 'Не отправлять',
  manual: 'Уже отправлено вручную',
}

export const OUTBOX_KIND = {
  downtime_notice: 'Уведомление о задержке',
  factory_breakdown: 'Претензия: срыв заводу',
  trip_correction: 'Просьба открыть рейс для корректировки',
}
